import { InputOption } from "../../classes/index";
import { ExtendedActionType } from "./index";

export interface IFilter {
    filterKey: string;
    chosenValue: string;
}

export function clearFilterSelections() {
    return {
        type: ExtendedActionType.ClearSelectedFilterOptions
    }
}

export function selectFilterOption(filter: IFilter) {
    return {
        type: ExtendedActionType.SelectFilterOption,
        value: filter
    }
}

export function swapToGridView() {
    return {
        type: ExtendedActionType.GoToGridView
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/redux/actions/filter-actions.ts